import { Box } from '../Box';
import styled from 'styled-components';
import * as styles from './styles';
import { FlexProps } from './Flex.types';
import {
  background,
  border,
  color,
  flexbox,
  grid,
  layout,
  space,
  position,
  shadow,
  typography,
  compose,
} from 'styled-system';

const Flex = styled(Box)<FlexProps>(
  () => styles.base,
  ({ inline }) => inline && styles.inline,
  compose(
    grid,
    flexbox,
    layout,
    border,
    background,
    space,
    color,
    position,
    typography,
    shadow
  )
);

export default Flex;
